export default "__VITE_ASSET__11728d6c__"